// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

.sudoku-game {
  --blue-dark: #1a6a7c;
  --blue-bg: #eef8ff;
  --red: #e15b5b;
  --text: #1d4056;
  --text-soft: #5f7c8b;
  min-height: 100vh;
  font-family: "Phenoma Light", sans-serif;
  color: var(--text);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding: 18px 16px 24px;
}

.sudoku-shell {
  max-width: 1100px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.56);
  border: 1px solid rgba(26, 106, 124, 0.12);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  padding: 14px 18px 18px;
}

.sudoku-game .modal.modal--window {
  top: 0;
  left: 0;
  max-width: 100vw;
}

.sudoku-game .modal--window .modal--fill {
  max-width: 100vw;
}

.sudoku-game .help-cards > div {
  max-width: calc(100vw - 70px);
}

.sudoku-game button {
  font-family: inherit;
}

.sudoku-game .modal--window * {
  font-family: "Phenoma Light", sans-serif;
}

.sudoku-game .help-cards h2 {
  margin: 0 0 6px;
  color: #1a6a7c;
  font-family: "Amatic SC", cursive;
  font-size: 22pt;
}

.sudoku-game .help-cards h2 + p {
  margin-top: 0;
}

.sudoku-top-bar {
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: center;
  gap: 16px;
  min-height: 72px;
}

.sudoku-header-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: min(100%, 510px);
  margin-left: 105px;
}

.sudoku-title-top {
  width: 100%;
  text-align: center;
  font-family: "Amatic SC", cursive;
  font-size: clamp(2.2rem, 3vw, 3.2rem);
  line-height: 0.9;
  letter-spacing: 0.06em;
  color: var(--blue-dark);
  font-weight: 700;
}

.sudoku-message-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.sudoku-logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 90px;
  text-decoration: none;
}

.sudoku-logo {
  width: 200px;
  height: auto;
  margin-left: 60px;
}

.sudoku-message-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  min-height: 26px;
  padding: 5px 12px;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid var(--blue-dark);
  border-radius: 16px;
  color: var(--blue-dark);
  font-size: clamp(1rem, 0.9vw, 0.8rem);
  font-weight: 800;
  text-align: center;
  box-shadow: inset 0 0 0 1px rgba(26, 106, 124, 0.15);
  align-self: flex-start;
}

.sudoku-help-icon {
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  opacity: 0.8;
  cursor: pointer;
  border-radius: 10px;
  object-fit: contain;
}

.sudoku-board-layout {
  display: grid;
  grid-template-columns: 170px minmax(280px, 1fr) 190px;
  align-items: center;
  gap: 18px;
  padding: 22px 18px 18px;
  margin-top: 12px;
}

.sudoku-side-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sudoku-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  background: var(--blue-bg);
  border: 1px solid #cfe6f9;
  border-radius: 18px;
  color: var(--blue-dark);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.sudoku-stat-label {
  font-size: 1.2rem;
  line-height: 1;
}

.sudoku-stat-value {
  display: block;
  margin-top: 6px;
  font-size: 1.02rem;
  font-weight: 900;
}

.sudoku-grid-wrapper {
  display: flex;
  justify-content: center;
  perspective: 1200px;
}

.sudoku-board-flipper {
  position: relative;
  width: min(100%, 510px);
  aspect-ratio: 1;
  transform-style: preserve-3d;
  transition: transform 0.85s ease-in-out;
}

.sudoku-board-flipper.is-flipped {
  transform: rotateY(180deg);
  transition-delay: 0.25s;
}

.sudoku-board-front,
.sudoku-board-back {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
}

.sudoku-board-flipper.is-flipped .sudoku-board-front,
.sudoku-board-flipper:not(.is-flipped) .sudoku-board-back {
  pointer-events: none;
}

.sudoku-grid {
  width: min(100%, 510px);
  aspect-ratio: 1 / 1;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(6, 1fr);
  background: var(--blue-dark);
  border: 4px solid var(--blue-dark);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 22px rgba(26, 106, 124, 0.18);
}

.sudoku-cell {
  min-width: 0;
  min-height: 0;
  background: #ffffff;
  border: 1px solid #dfeef8;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: background 0.12s ease, transform 0.12s ease;
}

.sudoku-cell:nth-child(3n) {
  border-right: 3px solid rgba(26, 106, 124, 0.8);
}

.sudoku-cell:nth-child(6n) {
  border-right: 1px solid #dfeef8;
}

.sudoku-cell:nth-child(n + 13):nth-child(-n + 18),
.sudoku-cell:nth-child(n + 25):nth-child(-n + 30) {
  border-top: 3px solid rgba(26, 106, 124, 0.8);
}

.sudoku-cell:hover {
  background: #f5fbff;
}

.sudoku-cell:active {
  transform: scale(0.96);
}

.sudoku-cell::before {
  content: "";
  width: clamp(18px, 5vw, 34px);
  height: clamp(18px, 5vw, 34px);
  border-radius: 50%;
  opacity: 0;
  transform: scale(0.52);
  transition: 0.15s ease;
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.55), 0 3px 7px rgba(0, 0, 0, 0.14);
}

.sudoku-cell.color-1::before,
.sudoku-cell.color-2::before,
.sudoku-cell.color-3::before,
.sudoku-cell.color-4::before,
.sudoku-cell.color-5::before,
.sudoku-cell.color-6::before {
  opacity: 1;
  transform: scale(1);
}

.sudoku-cell.color-1::before { background: linear-gradient(135deg, #ff8d8d, #e15b5b); }
.sudoku-cell.color-2::before { background: linear-gradient(135deg, #ffd773, #f4a53d); }
.sudoku-cell.color-3::before { background: linear-gradient(135deg, #86e7b7, #3ba876); }
.sudoku-cell.color-4::before { background: linear-gradient(135deg, #7ac2ff, #1e7bbd); }
.sudoku-cell.color-5::before { background: linear-gradient(135deg, #beb3ff, #6d61d5); }
.sudoku-cell.color-6::before { background: linear-gradient(135deg, #f5a8d9, #d96bb0); }

.sudoku-cell.fixed {
  cursor: default;
  background: #f5fbff;
}

.sudoku-cell.fixed::after {
  content: "★";
  position: absolute;
  right: 3px;
  top: 1px;
  font-size: 8px;
  color: rgba(26, 106, 124, 0.7);
  opacity: 0.8;
}

.sudoku-cell.selected {
  background: #edf8ff;
  box-shadow: inset 0 0 0 3px var(--blue-dark);
}

.sudoku-cell.error {
  box-shadow: inset 0 0 0 4px var(--red);
  animation: shake 0.3s;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.sudoku-palette {
  display: grid;
  grid-template-columns: repeat(6, minmax(26px, 1fr));
  gap: 8px;
  width: 100%;
  margin: 0 0 12px;
}

.sudoku-color-button {
  width: 100%;
  max-width: 82px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  transition: transform 0.12s ease;
  justify-self: center;
}

.sudoku-color-button:hover {
  transform: scale(1.08);
}

.sudoku-color-button.active {
  border-color: #123a4f;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.95), 0 0 0 6px rgba(26, 106, 124, 0.22);
}

.sudoku-color-button.color-1 { background: #e15b5b; }
.sudoku-color-button.color-2 { background: #f4a53d; }
.sudoku-color-button.color-3 { background: #3ba876; }
.sudoku-color-button.color-4 { background: #1e7bbd; }
.sudoku-color-button.color-5 { background: #6d61d5; }
.sudoku-color-button.color-6 { background: #d96bb0; }

.sudoku-instructions {
  text-align: center;
  color: var(--text-soft);
  font-size: 1rem;
  font-weight: 700;
  margin: 6px 0 12px;
}

.sudoku-buttons {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.sudoku-action-button {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 0.9vw;
  width: 100%;
  min-width: 0;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1vw;
  white-space: nowrap;
  background-color: #1a6a7c;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.sudoku-action-button:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.18);
}

.sudoku-board-back {
  display: flex;
  flex-direction: column;
  transform: rotateY(180deg);
  background: white;
  border: 4px solid var(--blue-dark);
  border-radius: 20px;
  padding: clamp(10px, 2vw, 20px);
  box-shadow: 0 12px 22px rgba(26, 106, 124, 0.18);
}

.sudoku-victory-illustration {
  position: relative;
  flex: 1 1;
  min-height: 0;
  border-radius: 12px;
  background: var(--blue-bg);
}

.sudoku-victory-illustration img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (prefers-reduced-motion: reduce) {
  .sudoku-board-flipper {
    transition: none;
  }
}

@media (max-width: 900px) {
  .sudoku-board-layout {
    grid-template-columns: 1fr;
  }

  .sudoku-side-panel {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .sudoku-side-left .sudoku-stat,
  .sudoku-side-right {
    flex: 1 1 120px;
  }
}

@media (max-width: 600px) {
  .sudoku-shell {
    padding: 10px 12px 14px;
  }

  .sudoku-top-bar {
    gap: 10px;
    grid-template-columns: min-content 1fr 22px;
    min-height: 58px;
  }

  .sudoku-logo-link {
    width: 70px;
    height: 46px;
  }

  .sudoku-logo {
    width: 62px;
  }

  .sudoku-message-bar {
    min-height: 38px;
    padding: 8px 12px;
    border-radius: 14px;
  }

  .sudoku-stat {
    min-height: 60px;
  }

  .sudoku-grid {
    border-width: 3px;
  }

  .sudoku-action-button {
    padding: 10px 6px;
    font-size: 0.65rem;
  }
}

@media (max-width: 380px) {
  .sudoku-top-bar {
    grid-template-columns: min-content 1fr 18px;
  }

  .sudoku-message-bar {
    font-size: 0.72rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Sudoku/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,yDAAqD;EACrD,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA;;;;;;EAME,UAAU;EACV,mBAAmB;AACrB;;AAEA,+BAA+B,qDAAqD,EAAE;AACtF,+BAA+B,qDAAqD,EAAE;AACtF,+BAA+B,qDAAqD,EAAE;AACtF,+BAA+B,qDAAqD,EAAE;AACtF,+BAA+B,qDAAqD,EAAE;AACtF,+BAA+B,qDAAqD,EAAE;;AAEtF;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mFAAmF;AACrF;;AAEA,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["* {\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.sudoku-game {\r\n  --blue-dark: #1a6a7c;\r\n  --blue-bg: #eef8ff;\r\n  --red: #e15b5b;\r\n  --text: #1d4056;\r\n  --text-soft: #5f7c8b;\r\n  min-height: 100vh;\n  font-family: \"Phenoma Light\", sans-serif;\n  color: var(--text);\r\n  background-image: url(\"../../img/dust_scratches.png\");\r\n  padding: 18px 16px 24px;\r\n}\r\n\r\n.sudoku-shell {\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n  background: rgba(255, 255, 255, 0.56);\r\n  border: 1px solid rgba(26, 106, 124, 0.12);\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\r\n  padding: 14px 18px 18px;\r\n}\n\n.sudoku-game .modal.modal--window {\n  top: 0;\n  left: 0;\n  max-width: 100vw;\n}\n\n.sudoku-game .modal--window .modal--fill {\n  max-width: 100vw;\n}\n\n.sudoku-game .help-cards > div {\n  max-width: calc(100vw - 70px);\n}\n\n.sudoku-game button {\n  font-family: inherit;\n}\n\n.sudoku-game .modal--window * {\n  font-family: \"Phenoma Light\", sans-serif;\n}\n\n.sudoku-game .help-cards h2 {\n  margin: 0 0 6px;\n  color: #1a6a7c;\n  font-family: \"Amatic SC\", cursive;\n  font-size: 22pt;\n}\n\n.sudoku-game .help-cards h2 + p {\n  margin-top: 0;\n}\n\r\n.sudoku-top-bar {\r\n  display: grid;\r\n  grid-template-columns: min-content 1fr;\r\n  align-items: center;\r\n  gap: 16px;\r\n  min-height: 72px;\r\n}\r\n\r\n.sudoku-header-center {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 20px;\r\n  width: min(100%, 510px);\r\n  margin-left: 105px;\r\n}\r\n\r\n.sudoku-title-top {\r\n  width: 100%;\r\n  text-align: center;\r\n  font-family: \"Amatic SC\", cursive;\n  font-size: clamp(2.2rem, 3vw, 3.2rem);\r\n  line-height: 0.9;\r\n  letter-spacing: 0.06em;\r\n  color: var(--blue-dark);\r\n  font-weight: 700;\r\n}\r\n\r\n.sudoku-message-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.sudoku-logo-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 150px;\r\n  height: 90px;\r\n  text-decoration: none;\r\n}\r\n\r\n.sudoku-logo {\r\n  width: 200px;\r\n  height: auto;\r\n  margin-left: 60px;\r\n}\r\n\r\n.sudoku-message-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n  min-height: 26px;\r\n  padding: 5px 12px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border: 2px solid var(--blue-dark);\r\n  border-radius: 16px;\r\n  color: var(--blue-dark);\r\n  font-size: clamp(1rem, 0.9vw, 0.8rem);\r\n  font-weight: 800;\r\n  text-align: center;\r\n  box-shadow: inset 0 0 0 1px rgba(26, 106, 124, 0.15);\r\n  align-self: flex-start;\r\n}\r\n\r\n.sudoku-help-icon {\r\n  width: 35px;\r\n  height: 35px;\r\n  flex-shrink: 0;\r\n  opacity: 0.8;\r\n  cursor: pointer;\r\n  border-radius: 10px;\r\n  object-fit: contain;\r\n}\r\n\r\n.sudoku-board-layout {\r\n  display: grid;\r\n  grid-template-columns: 170px minmax(280px, 1fr) 190px;\r\n  align-items: center;\r\n  gap: 18px;\r\n  padding: 22px 18px 18px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.sudoku-side-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.sudoku-stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 72px;\r\n  background: var(--blue-bg);\r\n  border: 1px solid #cfe6f9;\r\n  border-radius: 18px;\r\n  color: var(--blue-dark);\r\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.sudoku-stat-label {\r\n  font-size: 1.2rem;\r\n  line-height: 1;\r\n}\r\n\r\n.sudoku-stat-value {\r\n  display: block;\r\n  margin-top: 6px;\r\n  font-size: 1.02rem;\r\n  font-weight: 900;\r\n}\r\n\r\n.sudoku-grid-wrapper {\n  display: flex;\n  justify-content: center;\n  perspective: 1200px;\n}\n\n.sudoku-board-flipper {\n  position: relative;\n  width: min(100%, 510px);\n  aspect-ratio: 1;\n  transform-style: preserve-3d;\n  transition: transform 0.85s ease-in-out;\n}\n\n.sudoku-board-flipper.is-flipped {\n  transform: rotateY(180deg);\n  transition-delay: 0.25s;\n}\n\n.sudoku-board-front,\n.sudoku-board-back {\n  position: absolute;\n  inset: 0;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.sudoku-board-flipper.is-flipped .sudoku-board-front,\n.sudoku-board-flipper:not(.is-flipped) .sudoku-board-back {\n  pointer-events: none;\n}\n\r\n.sudoku-grid {\r\n  width: min(100%, 510px);\r\n  aspect-ratio: 1 / 1;\r\n  display: grid;\r\n  grid-template-columns: repeat(6, 1fr);\r\n  grid-template-rows: repeat(6, 1fr);\r\n  background: var(--blue-dark);\r\n  border: 4px solid var(--blue-dark);\r\n  border-radius: 20px;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 22px rgba(26, 106, 124, 0.18);\r\n}\r\n\r\n.sudoku-cell {\r\n  min-width: 0;\r\n  min-height: 0;\r\n  background: #ffffff;\r\n  border: 1px solid #dfeef8;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: background 0.12s ease, transform 0.12s ease;\r\n}\r\n\r\n.sudoku-cell:nth-child(3n) {\r\n  border-right: 3px solid rgba(26, 106, 124, 0.8);\r\n}\r\n\r\n.sudoku-cell:nth-child(6n) {\r\n  border-right: 1px solid #dfeef8;\r\n}\r\n\r\n.sudoku-cell:nth-child(n + 13):nth-child(-n + 18),\r\n.sudoku-cell:nth-child(n + 25):nth-child(-n + 30) {\r\n  border-top: 3px solid rgba(26, 106, 124, 0.8);\r\n}\r\n\r\n.sudoku-cell:hover {\r\n  background: #f5fbff;\r\n}\r\n\r\n.sudoku-cell:active {\r\n  transform: scale(0.96);\r\n}\r\n\r\n.sudoku-cell::before {\r\n  content: \"\";\r\n  width: clamp(18px, 5vw, 34px);\r\n  height: clamp(18px, 5vw, 34px);\r\n  border-radius: 50%;\r\n  opacity: 0;\r\n  transform: scale(0.52);\r\n  transition: 0.15s ease;\r\n  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.55), 0 3px 7px rgba(0, 0, 0, 0.14);\r\n}\r\n\r\n.sudoku-cell.color-1::before,\r\n.sudoku-cell.color-2::before,\r\n.sudoku-cell.color-3::before,\r\n.sudoku-cell.color-4::before,\r\n.sudoku-cell.color-5::before,\r\n.sudoku-cell.color-6::before {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n}\r\n\r\n.sudoku-cell.color-1::before { background: linear-gradient(135deg, #ff8d8d, #e15b5b); }\r\n.sudoku-cell.color-2::before { background: linear-gradient(135deg, #ffd773, #f4a53d); }\r\n.sudoku-cell.color-3::before { background: linear-gradient(135deg, #86e7b7, #3ba876); }\r\n.sudoku-cell.color-4::before { background: linear-gradient(135deg, #7ac2ff, #1e7bbd); }\r\n.sudoku-cell.color-5::before { background: linear-gradient(135deg, #beb3ff, #6d61d5); }\r\n.sudoku-cell.color-6::before { background: linear-gradient(135deg, #f5a8d9, #d96bb0); }\r\n\r\n.sudoku-cell.fixed {\r\n  cursor: default;\r\n  background: #f5fbff;\r\n}\r\n\r\n.sudoku-cell.fixed::after {\r\n  content: \"★\";\r\n  position: absolute;\r\n  right: 3px;\r\n  top: 1px;\r\n  font-size: 8px;\r\n  color: rgba(26, 106, 124, 0.7);\r\n  opacity: 0.8;\r\n}\r\n\r\n.sudoku-cell.selected {\r\n  background: #edf8ff;\r\n  box-shadow: inset 0 0 0 3px var(--blue-dark);\r\n}\r\n\r\n.sudoku-cell.error {\r\n  box-shadow: inset 0 0 0 4px var(--red);\r\n  animation: shake 0.3s;\r\n}\r\n\r\n@keyframes shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  25% { transform: translateX(-5px); }\r\n  75% { transform: translateX(5px); }\r\n}\r\n\r\n.sudoku-palette {\r\n  display: grid;\r\n  grid-template-columns: repeat(6, minmax(26px, 1fr));\r\n  gap: 8px;\r\n  width: 100%;\r\n  margin: 0 0 12px;\r\n}\r\n\r\n.sudoku-color-button {\r\n  width: 100%;\r\n  max-width: 82px;\r\n  aspect-ratio: 1;\r\n  border-radius: 50%;\r\n  border: 2px solid rgba(255, 255, 255, 0.9);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);\r\n  cursor: pointer;\r\n  transition: transform 0.12s ease;\r\n  justify-self: center;\r\n}\r\n\r\n.sudoku-color-button:hover {\r\n  transform: scale(1.08);\r\n}\r\n\r\n.sudoku-color-button.active {\r\n  border-color: #123a4f;\r\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.95), 0 0 0 6px rgba(26, 106, 124, 0.22);\r\n}\r\n\r\n.sudoku-color-button.color-1 { background: #e15b5b; }\r\n.sudoku-color-button.color-2 { background: #f4a53d; }\r\n.sudoku-color-button.color-3 { background: #3ba876; }\r\n.sudoku-color-button.color-4 { background: #1e7bbd; }\r\n.sudoku-color-button.color-5 { background: #6d61d5; }\r\n.sudoku-color-button.color-6 { background: #d96bb0; }\r\n\r\n.sudoku-instructions {\r\n  text-align: center;\r\n  color: var(--text-soft);\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  margin: 6px 0 12px;\r\n}\r\n\r\n.sudoku-buttons {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.sudoku-action-button {\r\n  display: flex;\r\n  gap: 0.5vw;\r\n  padding: 0.4vw 0.75vw;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: none;\r\n  border-radius: 0.9vw;\r\n  width: 100%;\r\n  min-width: 0;\r\n  cursor: pointer;\r\n  color: white;\r\n  place-self: center;\r\n  font-size: 1vw;\n  white-space: nowrap;\r\n  background-color: #1a6a7c;\r\n  transition: transform 0.12s ease, box-shadow 0.12s ease;\r\n}\r\n\r\n.sudoku-action-button:active {\r\n  transform: translateY(2px);\r\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.sudoku-board-back {\n  display: flex;\n  flex-direction: column;\n  transform: rotateY(180deg);\n  background: white;\n  border: 4px solid var(--blue-dark);\n  border-radius: 20px;\n  padding: clamp(10px, 2vw, 20px);\n  box-shadow: 0 12px 22px rgba(26, 106, 124, 0.18);\n}\n\n.sudoku-victory-illustration {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  border-radius: 12px;\n  background: var(--blue-bg);\n}\n\n.sudoku-victory-illustration img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sudoku-board-flipper {\n    transition: none;\n  }\n}\n\r\n@media (max-width: 900px) {\r\n  .sudoku-board-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .sudoku-side-panel {\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n\r\n  .sudoku-side-left .sudoku-stat,\r\n  .sudoku-side-right {\r\n    flex: 1 1 120px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .sudoku-shell {\r\n    padding: 10px 12px 14px;\r\n  }\r\n\r\n  .sudoku-top-bar {\r\n    gap: 10px;\r\n    grid-template-columns: min-content 1fr 22px;\r\n    min-height: 58px;\r\n  }\r\n\r\n  .sudoku-logo-link {\r\n    width: 70px;\r\n    height: 46px;\r\n  }\r\n\r\n  .sudoku-logo {\r\n    width: 62px;\r\n  }\r\n\r\n  .sudoku-message-bar {\r\n    min-height: 38px;\r\n    padding: 8px 12px;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  .sudoku-stat {\r\n    min-height: 60px;\r\n  }\r\n\r\n  .sudoku-grid {\r\n    border-width: 3px;\r\n  }\r\n\r\n  .sudoku-action-button {\r\n    padding: 10px 6px;\r\n    font-size: 0.65rem;\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  .sudoku-top-bar {\r\n    grid-template-columns: min-content 1fr 18px;\r\n  }\r\n\r\n  .sudoku-message-bar {\n    font-size: 0.72rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
